import React from 'react';
import styles from '../../index.css';

const Noria = (props) => {
        return(
            <div className={styles.noria + (props.culture ? ' ' + styles[props.culture] : '') + (props.noriaStatus ? ' ' + styles[props.noriaStatus] : '')}>
                <span/><span/><span/><span/>
                <div className={styles.noriaLineInput} />
                <div className={styles.noriaLineOutput} />
                <div className={styles.cloggedNoria}>!</div>
            </div>
        )
}
export default Noria;



// WEBPACK FOOTER //
// ./src/shared/components/Game/SubComponents/Noria/index.js